import React from "react";
import "./ReachOut.scss";

const ReachOut = ({ title, description }) => {
  return (
    <>
      <div className="reachout_sec1">
        <div className="my_container">
          <div className="text_container">
            <h6 className="title">{title}</h6>
            <p
              className="desc"
              dangerouslySetInnerHTML={{ __html: description }}
            ></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReachOut;
